import { createContext, useContext, useState, type ReactNode } from 'react';

interface EditCtx {
  editing: boolean;
  setEditing: (b: boolean) => void;
  toggle: () => void;
}

const Ctx = createContext<EditCtx | null>(null);

export function EditModeProvider({ children }: { children: ReactNode }) {
  const [editing, setEditing] = useState(false);
  return (
    <Ctx.Provider value={{ editing, setEditing, toggle: () => setEditing((v) => !v) }}>
      {children}
    </Ctx.Provider>
  );
}

export function useEditMode(): EditCtx {
  const c = useContext(Ctx);
  if (!c) throw new Error('useEditMode requires <EditModeProvider>');
  return c;
}
